import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Popover,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { IconBrandWhatsapp, IconBug, IconSend, IconX } from "@tabler/icons-react";
import {
  ANCHO_POPOVER_REPORTE,
  COLOR_REPORTAR_PROBLEMA as COLOR,
  MAX_COMENTARIO,
  POSICION_FLECHA,
  TAMANO_FLECHA,
  TEXTOS_REPORTAR_PROBLEMA as TXT,
} from "../constants/reportarProblema.constants";
import { useReportarProblema } from "../hooks/useReportarProblema";
import type { BotonReportarProblemaProps } from "../types/reportarProblema.types";
import { esAtajoEnviar, textoContador } from "../utils/reportarProblema.utils";

export const BotonReportarProblema = ({
  texto,
  textoHover,
  colorFondo,
  colorFondoHover,
  icono,
  onEnviar,
  deshabilitado = false,
}: BotonReportarProblemaProps): JSX.Element => {
  const {
    ancla,
    abierto,
    comentario,
    enviando,
    puedeEnviar,
    abrir,
    cerrar,
    cambiarComentario,
    enviar,
  } = useReportarProblema({ onEnviar });

  return (
    <>
      <Tooltip title={textoHover}>
        <IconButton
          disabled={deshabilitado}
          size="small"
          onClick={abrir}
          sx={{
            color: "#fff",
            backgroundColor: colorFondo ?? "",
            border: "1px solid rgba(255,255,255,0.6)",
            borderRadius: 1,
            gap: 0.5,
            "&:hover": {
              color: COLOR.textoHover,
              backgroundColor: colorFondoHover ?? COLOR.principal,
              //borderColor: COLOR.principal,
            },
            "&.Mui-disabled": {
              backgroundColor: COLOR.disabled,
              color: "rgba(255,255,255,0.5)",
              opacity: 0.6,
            },
          }}
        >
          {icono ?? <IconBug stroke={2} />} {texto}
        </IconButton>
      </Tooltip>

      {/*<Button
        variant="outlined"
        size="small"
        disabled={deshabilitado}
        startIcon={<IconBug stroke={2} size={20} />}
        onClick={abrir}
        sx={{
          color: "#fff",
          borderColor: "rgba(255,255,255,0.6)",
          textTransform: "none",
          "&:hover": {
            color: COLOR.textoHover,
            backgroundColor: COLOR.principal,
            borderColor: COLOR.principal,
          },
        }}
      >
        {texto}
      </Button>*/}

      <Popover
        open={abierto}
        anchorEl={ancla}
        onClose={cerrar}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        slotProps={{
          paper: {
            sx: {
              mb: 1.5,
              width: ANCHO_POPOVER_REPORTE,
              maxWidth: "calc(100vw - 32px)",
              borderRadius: 2,
              backgroundColor: COLOR.fondo,
              backgroundImage: "none",
              boxShadow: "0 8px 24px rgba(15, 23, 42, 0.18)",
              border: "1px solid",
              borderColor: COLOR.borde,
              overflow: "visible",
            },
          },
        }}
      >
        {/* Triangulito */}
        <Box
          sx={{
            position: "absolute",
            bottom: -(TAMANO_FLECHA / 2) - 1,
            left: POSICION_FLECHA - TAMANO_FLECHA / 2,
            width: TAMANO_FLECHA,
            height: TAMANO_FLECHA,
            backgroundColor: COLOR.fondo,
            borderRight: "1px solid",
            borderBottom: "1px solid",
            borderColor: COLOR.borde,
            transform: "rotate(45deg)",
            zIndex: 0,
          }}
        />

        <Box sx={{ p: 2, position: "relative", zIndex: 1 }}>
          <Typography
            variant="subtitle2"
            sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
          >
            <IconBug size={18} stroke={2} color={COLOR.principal} />
            {TXT.titulo}
          </Typography>

          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={3}
            maxRows={6}
            size="small"
            placeholder={TXT.placeholder}
            value={comentario}
            disabled={enviando}
            onChange={(e) => cambiarComentario(e.target.value)}
            onKeyDown={(e) => {
              if (esAtajoEnviar(e)) {
                e.preventDefault();
                enviar();
              }
            }}
            helperText={`${textoContador(comentario, MAX_COMENTARIO)} · ${TXT.atajo}`}
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1.5 }}>
            <Button
              size="small"
              onClick={cerrar}
              disabled={enviando}
              startIcon={<IconX size={16} stroke={2} />}
              sx={{ textTransform: "none", color: "text.secondary" }}
            >
              {TXT.cancelar}
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={enviar}
              disabled={!puedeEnviar}
              startIcon={
                enviando ? (
                  <CircularProgress size={14} color="inherit" />
                ) : (
                  <IconSend size={16} stroke={2} />
                )
              }
              sx={{
                textTransform: "none",
                color: "#fff",
                backgroundColor: COLOR.principal,
                "&:hover": { backgroundColor: COLOR.hover },
              }}
            >
              {enviando ? TXT.enviando : TXT.enviar}
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};
